export default "__VITE_ASSET__DAln6B1a__"